'use client';

import { ActionButtonsViewProps } from '@/components/action-buttons/action-buttons-view.types';
import { ActionButtonsButtonRow } from '@/components/action-buttons/ActionButtonsButtonRow';
import { ActionButtonsModals } from '@/components/action-buttons/ActionButtonsModals';

type ActionButtonsViewInternalProps = ActionButtonsViewProps & {
    renderModals?: boolean;
};

export const ActionButtonsView = ({
    buttonRowBindings,
    modalsBindings,
    renderModals = true,
}: ActionButtonsViewInternalProps) => {
    return (
        <div className="flex gap-2 items-center">
            <ActionButtonsButtonRow {...buttonRowBindings} />
            {renderModals ? <ActionButtonsModals {...modalsBindings} /> : null}
        </div>
    );
};
